export const ApplciationFeeFun = (
  feesType: any,
  feesStatus: any,
  feesChargeId: any,
  feesPaid: any
) => {
  if (feesType == "online") {
    if (feesStatus == "succeeded" && feesChargeId != "") {
      return "Paid";
    } else {
      return "Unpaid";
    }
  } else if (feesType == "ach_offline") {
    if (feesPaid == "true") {
      return "Paid";
    } else {
      return "Unpaid";
    }
  }
  return "";
};
